import { ReceiptSettingsService } from './model/squareup/buyerportal/receiptsettings/service';
import rpc from './rpc';

const receiptSettingsClient = ReceiptSettingsService.create(rpc());

export default receiptSettingsClient;
